<div class="comfort-padding" *ngIf="showRelatedTo()">
  <span class="font-weight-bold">{{ 'RELATED-TO' | translate }}: </span>&nbsp;
  <span *ngIf="!loading">
    <span *ngIf="showRelatedToChannel()">
      {{'PROGRAM' | translate}}: {{channel.name}}
    </span>
    <span *ngIf="showRelatedToEvent()">
      {{'EVENT' | translate}}: <a class="pointer" href (click)="showEventDetails($event)">
        {{event.eventTypeText}}
      </a><span class="text-lowercase">{{'ON' | translate}}</span> {{event.eventDateTime | date:"EEEE, MMMM d, y" }}
      <span class="text-lowercase">{{'AT' | translate}}</span>
      {{event.atTime}}
    </span>
    <span *ngIf="showRelatedToTask()">
      {{'TASK' | translate}}: <a [routerLink]="['/task', task.id]" [queryParams]="{breadcrumb: breadcrumb}"
        class="pointer">
        {{task.name}}
      </a>
    </span>
  </span>
</div>

<!--Event Details Dialog-->
<kendo-dialog title="{{ 'CLINICAL-EVENT-DETAILS' | translate }}" [width]="600" *ngIf="showClinicalEvents"
  (close)="closeEventDetails()">
  <div class="m-2">
    <h4>
      <span [className]="event.eventTypeIcon"></span>
      <span class="pl-2 montserrat event-type-text">{{event.eventTypeText}}</span>
    </h4>
    <div class="row mt-3">
      <div class="col-4">
        <span class="font-weight-bold">{{'CLINICAL-EVENT-DATE' | translate}}</span>
      </div>
      <div class="col-8">
        {{event.eventDateTime | date:"EEEE, MMMM d, y, h:mm:ss a" }}
      </div>
    </div>
    <div class="row mt-2" *ngIf="event.facility">
      <div class="col-4">
        <span class="font-weight-bold">{{'CLINICAL-EVENT-FACILITY' | translate}}</span>
      </div>
      <div class="col-8">
        {{event.facility}}
      </div>
    </div>
    <div class="row mt-2" *ngIf="event.appointment && event.appointment.providerFullName">
      <div class="col-4">
        <span class="font-weight-bold">{{'PROVIDER' | translate}}</span>
      </div>
      <div class="col-8">
        {{event.appointment.providerFullName}}
      </div>
    </div>
    <div class="row mt-2" *ngIf="event.details">
      <div class="col-4">
        <span class="font-weight-bold">{{'CLINICAL-EVENT-DETAILS' | translate}}</span>
      </div>
      <div class="col-8">
        {{event.details}}
      </div>
    </div>
    <div class="row" *ngIf="!event.appointment">
      <div class="col-4">
      </div>
      <div class="col-8">
        <input type="checkbox" [checked]="event.related" [disabled]="true" kendoCheckBox>
        <label class="k-checkbox-label">{{'EVENT-RELATED' | translate}}</label>
      </div>
    </div>
    <!--Encounter Type Event-->
    <div *ngIf="event.encounter" class="mt-2">
      <div class="row"
        *ngIf="event.encounter.treatingProvider || event.encounter.providerPhoneNumber || event.encounter.providerEmail">
        <div class="col-4">
          <span class="font-weight-bold">{{'TREATING-PROVIDER' | translate}}</span>
        </div>
        <div class="col-8">
          <i *ngIf="event.encounter.treatingProvider"
            class="fas fa-user-md"></i>&nbsp;{{event.encounter.treatingProvider}}
          <div *ngIf="event.encounter.providerPhoneNumber">
            <i class="fas fa-phone"></i>&nbsp;{{event.encounter.providerPhoneNumber | phone}}
          </div>
          <div *ngIf="event.encounter.providerEmail">
            <i class="fas fa-envelope"></i>&nbsp;{{event.encounter.providerEmail}}
          </div>
        </div>
      </div>
      <div *ngIf="event.encounter.encounterNumber" class="row mt-2">
        <div class="col-6">
          <span class="font-weight-bold">{{'ENCOUNTER-NUMBER' | translate}}</span>
        </div>
        <div class="col-8">
          {{event.encounter.encounterNumber}}
        </div>
      </div>
    </div>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="closeEventDetails()">{{'CLOSE' | translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>